module.exports = __webpack_public_path__ + "img/m11.d6e7683a.jpg";